import React, { useState,useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import { notifyError, notifySuccess, validateEmail } from "../../helper";
import client from "../../api";
import Mate from "./Mate";
import BlockLoader from "../BlockLoader";


const TeamMates = () => {
    const api =client();
    const [users, setusers] = useState([]);
    const [error, setError] = useState('');
    const [loader,setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [memberEmail, setMemberEmail] = useState('');
    const [memberName, setMemberName] = useState('');
    const [offset, setOffset] = useState(0);
    const [limit] = useState(10); // Load 10 users at a time
    const [hasMore, setHasMore] = useState(true);
    const addCheckedStatus = (data) => {
        const updatedData = data.map((v,i)=>({...v,isChecked:false}));
        setusers(updatedData);
    }

    const getAllUsers = async (append = false) => {
        try {
            setLoader(true);
            const response = await api.post('/v1/user/search', { offset, limit });
            if (response.status === 200 || response.status === 201) {
                const data = response.data.users_list;
    
                if (append) {
                    addCheckedStatus([...users, ...data]);
                } else {
                    addCheckedStatus(data);
                }
    
                setHasMore(data.length === limit); // Check if more data exists
            }
        } catch (error) {
            console.log('error.message', error);
            if (error.status === 400) notifyError('Bad Request. Unable to fetch Users. Please try again');
        } finally {
            setLoader(false);
        }
    };

    const handleLoadMore = () => {
        setOffset(prevOffset => prevOffset + limit);
    };

    useEffect(() => {
        getAllUsers(offset > 0); // Append only if offset > 0
    }, [offset]);

    // Function to send invite to new member's email address, if validation get apssed
    const submitSendInvite = async () => {
        if(validateField(memberName, memberEmail)){
            try{   
                setLoading(true);         
                const response = await api.post('/v1/user/invite',{
                    email:memberEmail,
                    name: memberName
                });
            
                if(response.status === 200 ||  response.status === 201){
                    notifySuccess('An invite has been sent to the new team member\'s email address.');
                    setLoading(false);
                    setTimeout(()=>{
                        setMemberEmail('');
                        setMemberName('');
                        window.location.reload();
                    },1000);
                    
                }
            } catch(error) {
                setLoading(false);
                console.log('error.message',error);
                if(error.status === 409) notifyError('This email is already exists. Please add a different user');
                if(error.status === 400) notifyError('Bad Request. Not able to send invite to add team member.');
            }
        } 
        
    }

    // Validate member name and email fields and show error message accordingly
    const validateField = (memberName, memberEmail) => {
        setError('');
        if(!memberName.length){
            setError('Full name field cannot be blank.');
            return false;
        } else if(!memberEmail.length){
            setError('Email address field cannot be blank.');
            return false;
        } else if(!validateEmail(memberEmail)){
            setError('Invalid email address');
            return false;
        } else {
            return true;
        }
    }

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="teammates-wrap">
                <div className="top-section">
                    <h1>Team Members</h1>
                    <div className="add-team-member">
                        <h4>Add Team Member</h4>
                        <div className="add-team-member-inner">
                            <div className="field-wrap flex-2">
                                <label className="label-xs">Their full name</label>
                                <input 
                                    type="text" 
                                    name="member_name"
                                    placeholder="Their full name" 
                                    value={memberName}
                                    onChange={(e)=>{
                                        setMemberName(e.target.value);
                                    }}
                                    onFocus={()=>{setError('')}}
                                    onBlur={(e)=>{
                                        setError('');
                                        validateField(memberName, memberEmail);
                                    }}
                                />
                            </div>
                            <div className="field-wrap flex-2">
                                <label className="label-xs">Their email address</label>
                                <input 
                                    type="email" 
                                    placeholder="Their email address" 
                                    value={memberEmail}
                                    onChange={(e)=>{
                                        setMemberEmail(e.target.value);
                                    }}
                                    onFocus={()=>{setError('')}}
                                    onBlur={(e)=>{
                                        setError('');
                                        validateField(memberName, memberEmail);
                                    }}
                                />
                            </div>
                            {/* <div className="field-wrap flex-1">
                                <label className="label-xs">&nbsp;</label>
                                <label className="label-wrap" htmlFor="make-admin">
                                <input type="checkbox" id="make-admin"/>Make administrator 
                                </label>
                            </div> */}
                            <div className="field-wrap flex-1">
                                <label className="label-xs">&nbsp;</label>
                                <button
                                    type="button" 
                                    name="sendinvite-submit"
                                    disabled={loading}
                                    className={loading ? "primary-btn button--loading":"primary-btn"}   
                                    onClick={()=>{
                                        submitSendInvite();
                                    }}><span className="button--text">Send Invite</span></button>
                                    {error && <span className="validation-error">{error}</span>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="members-list-wrap">
                    <div className="top-info">
                        {/* <p>Administrators can update billing, connect new mail accounts, and invite people.</p> */}
                    </div>
                    <div className="members-list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                            {loader ? <tr><td colSpan={4}><BlockLoader height={"300px"} /></td></tr>: <>
                                {users.map((row,i)=>(<Mate userinfo={row} key={i} />))}
                                </>}
                            </tbody>
                        </table>
                        <div className="more-records">
                            {hasMore && !loader && (
                                <button onClick={handleLoadMore}>
                                    <i className="bx bx-chevron-down"></i>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>);
}

export default TeamMates;